export default "__VITE_ASSET__D9P7apdR__"